import { Suspense } from 'react';

import { AppLoader, PageTitle, PageWrapper } from '@ingrid/luterkort-react';

import { useTranslation } from '~src/i18n/use-translation';

import { Dashboard } from './components/dashboard';
import { VariantBanner } from './components/variant-banner';

export function Page() {
  const { t } = useTranslation();

  return (
    <PageWrapper>
      <PageTitle.Wrapper>
        <PageTitle.Stack>
          <PageTitle.Title>{t('common.dashboard')}</PageTitle.Title>
        </PageTitle.Stack>
      </PageTitle.Wrapper>

      <Suspense fallback={<AppLoader />}>
        <VariantBanner />
        <Dashboard />
      </Suspense>
    </PageWrapper>
  );
}
